import { Link, useParams } from 'react-router';
import { useProject } from '../api/queries';
import { useTranslate } from '../i18n/useTranslate';
import { ErrorView } from '../ui/ErrorView';

export function ProjectDetailPage() {
  const t = useTranslate();
  // React Router paramları string|undefined; tip güvenliği elle kurulur.
  const { projectId = '' } = useParams<{ projectId: string }>();
  const project = useProject(projectId);

  if (project.isPending) return <p>{t('projects.loading')}</p>;
  if (project.isError) return <ErrorView error={project.error} onRetry={() => void project.refetch()} />;

  return (
    <article>
      {/*
        * Göreli: bir üst segment. Sabit '/projects' yazmak, bölüm yolu
        * değişirse bayatlayacak dördüncü bir kopya olurdu (SEOAI-47 kapısı).
        * Burada izin sorunu YOK — bu sayfayı görebilen zaten project.view'a
        * sahiptir — ama kopya yine de gereksiz.
        */}
      <Link to=".." relative="path">{t('projects.back')}</Link>
      <h1>{project.data.name}</h1>

      <dl>
        <dt>{t('projects.type')}</dt>
        <dd>{project.data.type}</dd>

        <dt>{t('projects.status')}</dt>
        <dd>{project.data.status}</dd>

        {project.data.websiteUrl && (
          <>
            <dt>{t('projects.website')}</dt>
            <dd>{project.data.websiteUrl}</dd>
          </>
        )}

        <dt>{t('projects.analyses')}</dt>
        <dd>{project.data.availableAnalyses.join(', ') || '—'}</dd>
      </dl>
    </article>
  );
}
